var React = require('react');

function ExternalInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M16.1133 22.2148L28.0875 10.2406","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M19.1133 9.41406H29.1162L29.1162 19.0813","strokeWidth":"2","key":1}),React.createElement("path",{"d":"M26.1133 23.7422V29.2422H9.11328V12.2422H14.1133","strokeWidth":"2","key":2})]);
}

ExternalInline.defaultProps = {"width":"38","height":"38","viewBox":"0 0 38 38","fill":"none"};

module.exports = ExternalInline;

ExternalInline.default = ExternalInline;
